import styles from './index.module.css'

const CloudTwoSVG = () => {
  return <img className={styles.svg} src="/images/home/cloud-two.svg" />
}

export default CloudTwoSVG
